import React, { useEffect, useState } from "react";
import withIntl from "../../../../utils/withIntl";
import { Button, Checkbox, FormControlLabel, Grid, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import PrintArticleLine from "../../PrintArticleLine";
import PrintTakeawayBillView from "./PrintTakeawayBillView";
import cloudStore from "../../../../store/CloudStore";

function TakeawayBillLayoutEdit(props) {
  const layoutOptions = props.layoutOptions;
  const setLayoutOptions = props.setLayoutOptions;
  const [paymentMethods, setPaymentMethods] = useState(null);
  const [selectedPaymentMethods, setSelectedPaymentMethods] = useState(
    props.layoutOptions.ta_total_receipt?.payment_methods
      ? Object.keys(props.layoutOptions.ta_total_receipt.payment_methods).reduce((keys, key) => {
          if (props.layoutOptions.ta_total_receipt.payment_methods[key] === 1) {
            keys.push(key);
          }
          return keys;
        }, [])
      : []
  );
  const [printAll, setPrintAll] = useState(props.layoutOptions.ta_total_receipt?.payment_methods == null);

  useEffect(() => {
    let paymentMethods = [];
    cloudStore.merchant.ta_merchants.forEach((merchant) => {
      if (merchant.payment_methods != null) {
        JSON.parse(merchant.payment_methods).forEach((paymentMethod) => {
          if (
            !paymentMethods.map((uniqueMethod) => Object.keys(uniqueMethod)[0]).includes(Object.keys(paymentMethod)[0])
          ) {
            paymentMethods.push(paymentMethod);
          }
        });
      }
    });

    cloudStore.merchant.sp_merchants.forEach((merchant) => {
      if (merchant.payment_methods != null) {
        merchant.payment_methods.forEach((paymentMethod) => {
          if (
            !paymentMethods.map((uniqueMethod) => Object.keys(uniqueMethod)[0]).includes(Object.keys(paymentMethod)[0])
          ) {
            paymentMethods.push(paymentMethod);
          }
        });
      }
    });
    setPaymentMethods(paymentMethods);
  }, []);

  return (
    <>
      <Typography variant={"h6"} style={{ fontWeight: 800 }}>
        Takeaway Bill
      </Typography>
      <Grid container>
        <Grid container spacing={1} item xs={8}>
          <Grid item xs={6}>
            {props.intl.formatMessage({ id: "header" })}
          </Grid>
          <Grid item xs={6}>
            <TextField
              multiline={true}
              value={layoutOptions.ta_order_total_receipt.header}
              onChange={(e) => {
                layoutOptions.ta_order_total_receipt.header = e.target.value;
                setLayoutOptions({ ...layoutOptions });
              }}
            />
          </Grid>
          <Grid item xs={6}>
            {props.intl.formatMessage({ id: "footer" })}
          </Grid>
          <Grid item xs={6}>
            <TextField
              multiline={true}
              value={layoutOptions.ta_order_total_receipt.footer}
              onChange={(e) => {
                layoutOptions.ta_order_total_receipt.footer = e.target.value;
                setLayoutOptions({ ...layoutOptions });
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography>{props.intl.formatMessage({ id: "article_layout" })}</Typography>
            {layoutOptions.ta_order_total_receipt.article &&
              layoutOptions.ta_order_total_receipt.article.lines.map((articleLine, index) => {
                return (
                  <PrintArticleLine
                    articleLine={articleLine}
                    onRemoveLine={() => {
                      layoutOptions.ta_order_total_receipt.article.lines.splice(index, 1);

                      setLayoutOptions({ ...layoutOptions });
                    }}
                    setArticleLine={(newArticleLine) => {
                      articleLine = newArticleLine;
                      let newLayoutOptions = { ...layoutOptions };

                      setLayoutOptions(newLayoutOptions);
                    }}
                  />
                );
              })}
          </Grid>
          <Grid item xs={12}>
            <Button
              variant={"outlined"}
              size={"small"}
              onClick={() => {
                layoutOptions.ta_order_total_receipt.article.lines.push({ elements: [] });
                setLayoutOptions({ ...layoutOptions });
              }}
            >
              Add new line
            </Button>
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order_total_receipt.article.newline ?? false}
                  onChange={(e) => {
                    layoutOptions.ta_order_total_receipt.article.newline = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"New line"}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order_total_receipt.print_vats ?? true}
                  onChange={(e) => {
                    layoutOptions.ta_order_total_receipt.print_vats = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Print VAT's"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={printAll}
                  onChange={(e) => {
                    setPrintAll(e.target.checked);
                    if (e.target.checked) {
                      delete layoutOptions.ta_total_receipt.payment_methods;
                    } else {
                      if (!layoutOptions.ta_total_receipt) {
                        layoutOptions.ta_total_receipt = {};
                      }
                      if (!layoutOptions.ta_total_receipt.payment_methods) {
                        layoutOptions.ta_total_receipt.payment_methods = {};
                      }
                    }
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Print for all payment methods"}
            />
            {!printAll && paymentMethods && (
              <Select
                color={"primary"}
                multiple={true}
                label={"Print for specific payment methods"}
                value={selectedPaymentMethods}
                onChange={(e) => {
                  setSelectedPaymentMethods(e.target.value);
                  Object.keys(layoutOptions.ta_total_receipt.payment_methods).forEach((paymentMethodKey) => {
                    layoutOptions.ta_total_receipt.payment_methods[paymentMethodKey] = 0;
                  });
                  e.target.value.forEach((paymentMethodKey) => {
                    layoutOptions.ta_total_receipt.payment_methods[paymentMethodKey] = 1;
                  });

                  setLayoutOptions({ ...layoutOptions });
                }}
              >
                {paymentMethods.map((paymentMethod) => {
                  return (
                    <MenuItem value={Object.keys(paymentMethod)[0]}>
                      {Object.keys(paymentMethod)[0]["description"] ?? Object.keys(paymentMethod)[0]}
                    </MenuItem>
                  );
                })}
              </Select>
            )}
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order_total_receipt.drawers_pins_on ?? false}
                  onChange={(e) => {
                    layoutOptions.ta_order_total_receipt.drawers_pins_on = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Cash drawer"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order_total_receipt.print_address_qrcode ?? false}
                  onChange={(e) => {
                    layoutOptions.ta_order_total_receipt.print_address_qrcode = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Print QR Code address"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order_total_receipt.hide_pickup_timestamp ?? false}
                  onChange={(e) => {
                    layoutOptions.ta_order_total_receipt.hide_pickup_timestamp = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Hide pickup/delivery timestamp"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order_total_receipt.buzzer ?? false}
                  onChange={(e) => {
                    layoutOptions.ta_order_total_receipt.buzzer = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Play buzzer when printing"}
            />
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <PrintTakeawayBillView layoutOptions={layoutOptions.ta_order_total_receipt} />
        </Grid>
      </Grid>
    </>
  );
}

export default withIntl(TakeawayBillLayoutEdit);
